import { apiCrm } from '../../../../http';
class WhiteListService {
  async create({ ip_origem, host }) {
    return apiCrm.post('/white-list', {
      ip_origem,
      host
    });
  }

  async getById(id) {
    return apiCrm.get(`/white-list/${id}`);
  }

  async getAll({ showDisabled = false }) {
    return apiCrm.get('/white-list/all', {
      params: {
        showDisabled
      }
    });
  }

  async getWithPagination({
    page = 1,
    limit = 10,
    showIsEnable = true,
    ip_origem = '',
    host = ''
  }) {
    let response = await apiCrm.get('/white-list', {
      params: {
        page,
        limit,
        showIsEnable,
        ip_origem
      }
    });
    if (response.data && response.data.data.result.length > 0) return response;

    response = await apiCrm.get('/white-list', {
      params: {
        page,
        limit,
        showIsEnable,
        host
      }
    });

    return response;
  }

  async getWithPaginationAndSearch(page = 1, showIsEnable = true, ip_origem) {
    return apiCrm.get('/white-list', {
      params: {
        page,
        limit: 30,
        showIsEnable,
        ip_origem
      }
    });
  }

  async update(id, { ip_origem, host }) {
    return apiCrm.put(`/white-list/${id}`, {
      ip_origem,
      host
    });
  }

  async changeStatus(id) {
    return apiCrm.put(`/white-list/status/${id}`);
  }
}

export default new WhiteListService();
